import { render, staticRenderFns } from "./ApplicationListConfirmSendMessageModal.vue?vue&type=template&id=66bfa512&"
import script from "./ApplicationListConfirmSendMessageModal.vue?vue&type=script&lang=js&"
export * from "./ApplicationListConfirmSendMessageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports